import React, { memo } from 'react'
import { styled } from 'opensolar-ui'

const Container = styled('div')(() => ({
  fontSize: '12px',
  borderRadius: '4px',
  padding: '3px 10px',
  backgroundColor: '#D32F2F',
  color: '#ffffff',
}))


const PercentageDiscountTag = ({ showUpTo, percentage }: { showUpTo: boolean; percentage: string }) => {
  return <Container>{showUpTo ? `UP TO ${percentage}% OFF` : `${percentage}% OFF`}</Container>
}

export default memo(PercentageDiscountTag)
